// extracted by mini-css-extract-plugin
export default {"sessionTimer":"SessionTimer_sessionTimer__Paht3","sessionTimerIcon":"SessionTimer_sessionTimerIcon__iF6Kh","sessionTimerText":"SessionTimer_sessionTimerText__bxQqn"};